// Where Pair's live chat may show, from the engine's settings file, so it is
// switched without a new build (backend-api ChatSettingsController):
//
//   website  the website's Contact and My Account pages
//   apps     the apps: the old apps' contact page (/app/contactus), shown in a
//            small window, and the newer apps' own chat (app-chat.html)
//
// Asked once per page load. When the engine cannot be asked, or its answer is
// not what is expected, the defaults below are used: the same as the engine's
// own defaults.

import * as Constants from "../../Constants/index";

export const CHAT_DEFAULTS = Object.freeze({ website: true, apps: false });

export function chatSettingsFrom(body) {
  return {
    website: typeof body?.website === "boolean" ? body.website : CHAT_DEFAULTS.website,
    apps: typeof body?.apps === "boolean" ? body.apps : CHAT_DEFAULTS.apps,
  };
}

let asked;

export function chatSettings() {
  if (!asked) {
    asked = fetch(Constants.api + "chat/settings", { cache: "no-store" })
      .then((response) => (response.ok ? response.json() : undefined))
      .then(chatSettingsFrom)
      .catch(() => chatSettingsFrom(undefined));
  }
  return asked;
}

// For tests: ask the engine again.
export function forgetChatSettings() {
  asked = undefined;
}
